import React from "react";
import { Link } from "react-router-dom";
import "./ServicePages.css";
import Seo from "../components/Seo";

const FastFlash = () => {
  return (
    <div className="page-shell" data-theme="fast-flash">
      <Seo
        title="J3 Fast Flash Touch-Up Painting | Kingwood & Houston"
        description="Fast Flash one-day refresh painting in Kingwood and Houston for busy homes, rentals, and Airbnbs with targeted repairs and crisp lines."
        canonicalPath="/fast-flash"
        image="/logo192.png"
      />
      <div className="page-wrap">
        <div className="page-hero">
          <p className="page-eyebrow">One-Day Refresh</p>
          <h1>J3 Fast Flash™ Touch-Up</h1>
          <p className="lead">
            Flat-rate, quick-turn paint refresh for landlords, Airbnb hosts, and busy
            homeowners who need a clean reset without shutting down the space.
          </p>
          <div className="pill-row">
            <span className="pill">Package-style SKUs</span>
            <span className="pill">Stain blocking & repairs</span>
            <span className="pill">Rapid scheduling</span>
          </div>
          <div className="cta-row">
            <Link to="/quote" className="btn primary">
              Get a Fast Flash quote
            </Link>
            <Link to="/interior-decals" className="btn ghost">
              See Interior Decals
            </Link>
          </div>
        </div>

        <div className="section-block">
          <h2>What we focus on</h2>
          <div className="bullet-grid">
            <div className="bullet-card">
              <h3>Landlords & property managers</h3>
              <ul>
                <li>Turn units quickly without sacrificing finish quality.</li>
                <li>Predictable SKUs: up to X rooms / Y sq ft packages.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Airbnb / short-term rentals</h3>
              <ul>
                <li>Fix the worst visual sins between bookings.</li>
                <li>Keep your photo wall and main shots guest-ready.</li>
              </ul>
            </div>
            <div className="bullet-card">
              <h3>Busy homeowners</h3>
              <ul>
                <li>High-traffic touch-ups without a full repaint.</li>
                <li>Professional cut lines, proper primers, minimal downtime.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="section-block">
          <h2>How Fast Flash works</h2>
          <div className="steps">
            <div className="step">
              <strong>Step 1:</strong> Share photos and the zones that bother you most.
            </div>
            <div className="step">
              <strong>Step 2:</strong> Choose a flat-rate SKU that fits your rooms/sq ft.
            </div>
            <div className="step">
              <strong>Step 3:</strong> We schedule, prep, and complete in one tight window.
            </div>
          </div>
          <p className="note">
            We are anti-DIY shaming. We simply bring the right primers, paints, and sequence so
            the refresh actually lasts.
          </p>
        </div>

        <div className="quote-box">
          <h2>Keep bookings live. Keep walls honest.</h2>
          <p>
            Tell us what needs to look new. We’ll price the package, handle the prep, and get
            you back to business fast.
          </p>
          <Link to="/quote" className="btn primary">
            Start a Fast Flash request
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FastFlash;
